module.exports = cptable;


//////////////////
// WEBPACK FOOTER
// external "cptable"
// module id = 784
// module chunks = 63